// src/config/agentConfig.js
// -----------------------------------------------------------------------------
// Configuration des agents (Lux, DIP, Experts)
// Accessible partout dans l'application
// -----------------------------------------------------------------------------

export const agentConfig = {
  lux: {
    type: 'voiceflow',
    apiKey: process.env.REACT_APP_VF_LUX_API_KEY,
    jobId: 0,
    getBotInfos: (user, bot) => ({
      name: "Lux",
      job: user?.gender === 'girl' ? "Conseillère en orientation" : "Conseiller en orientation",
      gender: user?.gender || 'boy',
      avatar: user?.gender === 'girl'
        ? "https://images.unsplash.com/photo-1573497019940-1c28c88b4f3e?q=80&w=200"
        : "https://images.unsplash.com/photo-1618077360395-f3068be8e001?q=80&w=200",
      video: "/assets/lux-video-new.mp4",
      bio: `Salut ${user?.firstName || 'toi'} ! Je suis Lux, ton guide d'orientation. Je suis là pour t'aider à découvrir les métiers, répondre à tes questions et t'accompagner dans tes choix. Prêt(e) à explorer ?`,
      suggestions: []
    }),
    getInitVariables: (user, history) => ({
      "child_firstname": user.firstName,
      "CIAO_user_gender_en": user.gender,
      "child_age": user.age,
      "history": history ? history.map(item => item.content).join("\n") : ''
    })
  },

  dip: {
    type: 'dify',
    jobId: 'dip',
    getBotInfos: (user, bot) => ({
      name: "Dip",
      job: "",
      gender: user?.gender || 'boy',
      avatar: user?.gender === 'girl'
        ? "https://images.unsplash.com/photo-1494790108377-be9c29b29330?q=80&w=200"
        : "https://images.unsplash.com/photo-1535713875002-d1d0cf377fde?q=80&w=200",
      video: "/assets/dip-video.mp4",
      bio: `Salut ${user?.firstName || 'toi'} ! Je suis DIP, ton assistant intelligent pour la découverte des formations et de écoles.`,
      suggestions: [
        'Quelles sont les études en alternance dans le domaine du tourisme ?',
        'Quelles études faut-il faire pour le métier qui m\'attire ?',
        'Quelles sont les prépas ECG les plus proche de chez moi ?'
      ]
    })
  },

  sup: {
    type: 'dify',
    jobId: 'sup',
    getBotInfos: (user, bot) => ({
      name: "Sup",
      job: "",
      gender: user?.gender || 'boy',
      avatar: user?.gender === 'girl'
        ? "https://images.unsplash.com/photo-1494790108377-be9c29b29330?q=80&w=200"
        : "https://images.unsplash.com/photo-1535713875002-d1d0cf377fde?q=80&w=200",
      video: "/assets/sup-video.mp4",
      bio: `Salut ${user?.firstName || 'toi'} ! Je suis SUP, ton assistant intelligent pour Parcoursup.`,
      suggestions: [
        'Quelles sont les prochaines échéances Parcoursup ?',
        'Comment construire une liste de vœux équilibrée ?',
        'Comment bien remplir ma rubrique Activités ?',
      ]
    })
  },


  expert: {
    type: 'voiceflow',
    apiKey: process.env.REACT_APP_VF_API_KEY,
    getBotInfos: (user, bot) => ({
      name: bot.name,
      job: bot.gender === 'boy' ? bot.job.title_m : bot.job.title_f,
      gender: bot.gender,
      avatar:  bot.gender === 'boy' ? bot.job.aws_pictures_m[1] : bot.job.aws_pictures_f[1],
      bio: ``,
      suggestions: []
    }),
    getInitVariables: (user, history, values) => ({
      "CIAO_bot_firstname": values.name,
      "CIAO_bot_gender": values.gender,
      "CIAO_user_firstname": user.firstName,
      "CIAO_user_gender_en": user.gender,
      "CIAO_user_age": user.age,
      "CIAO_job_title": values.title_for_prompt,
      "CIAO_job_expected_qualities": values.qualities,
      "CIAO_job_salary": values.salary,
      "CIAO_job_salary_evolution_explanation": values.salary_evolution_explanation,
      "CIAO_job_level_of_education": values.level_of_education,
      "CIAO_job_speciality": values.speciality,
      "CIAO_user_history": history ? history.map(item => item.content).join("\n") : ''
    })
  }
};

/**
 * Détermine le type d'agent à partir de l'ID
 */
export function getAgentType(id) {
  if (id === 'lux') return 'lux';
  if (id === 'dip') return 'dip';
  if (id === 'sup') return 'sup';
  return 'expert';
}

/**
 * Génère l'ID de chat pour une conversation
 */
export function getChatId(id, gender) {
  if (id === 'lux' || id === 'dip' || id === 'sup') return id;
  return `${id}/${gender}`;
}

/**
 * Récupère le jobId Xano pour un agent
 */
export function getXanoJobId(agentType, values) {
  if (agentType === 'lux') return 'lux';
  if (agentType === 'dip') return 'dip';
  if (agentType === 'sup') return 'sup';
  return values?.id;
}